export default __webpack_public_path__ + "static/media/searching-empty.163e48ba.svg";